import About from "../../components/About/About";
export default function Abouts() {
  return <About />;
}
